export const INITIAL_USER_REQUEST = "INITIAL_USER_REQUEST";
export const FINAL_USER_REQUEST = "FINAL_USER_REQUEST";

export const FETCH_USER_SUCCESS = "FETCH_USER_SUCCESS";
export const FETCH_USER_ERROR = "FETCH_USER_ERROR";

export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS";
export const SAVE_USER_SUCCESS = "SAVE_USER_SUCCESS";
